<div *ngIf="isLoading !== false" class="skeleton-container">
  <nz-skeleton nzActive="true"> </nz-skeleton>
</div>
<ng-container *ngIf="isLoading == false" style="width: 100% !important; padding: 0px; margin-left: 0px">
  <nz-tabset class="tab-set" (nzSelectChange)="tabChange($event)" [nzSelectedIndex]="selectedTab">
    <nz-tab *ngFor="let tab of tabs" class="tab-item" [nzTitle]="titleTemplate">
      <ng-template #titleTemplate>
        {{ tab.label | locale }}
        <i nz-icon [nzType]="tab.icon" style="margin-left: 7px"></i>
      </ng-template>

      <div *ngIf="tab.label === 'Email'">
        <div class="tab-item">
          <nz-select [(ngModel)]="listOfTagOptions" nzMode="tags" [nzTokenSeparators]="[',']"
            nzPlaceHolder="{{ 'Assign to Employees' | locale }}">
            <nz-option *ngFor="let option of listOfOption" [nzLabel]="option.label" [nzValue]="option.value">
            </nz-option>
          </nz-select>
        </div>
        <nz-space-item class="tab-item">
          <nz-select [(ngModel)]="emailListOfTagOptions" #toEmailEle nzMode="tags" (nzOnSearch)="emailList($event)"
            [nzTokenSeparators]="[',']" nzPlaceHolder="{{ 'To' | locale }}">
            <nz-option *ngFor="let option of emailListOfOption" [nzLabel]="option.label" [nzValue]="option.value">
            </nz-option>
          </nz-select>
        </nz-space-item>

        <nz-space-item class="tab-item">
          <nz-select [(ngModel)]="cCemailListOfTagOptions" (nzOnSearch)="emailList($event)" nzMode="tags"
            [nzTokenSeparators]="[',']" nzPlaceHolder="{{ 'Cc' | locale }}">
            <nz-option *ngFor="let option of emailListOfOption" [nzLabel]="option.label" [nzValue]="option.value">
            </nz-option>
          </nz-select>
        </nz-space-item>

        <nz-space-item class="tab-item">
          <nz-upload [(nzFileList)]="fileList" [nzBeforeUpload]="beforeUpload">
            <button nz-button>
              <i nz-icon nzType="upload"></i>{{ "Attachment" | locale }}
            </button>
          </nz-upload>
        </nz-space-item>

        <label nz-checkbox [(ngModel)]="messageInfo.sendPdf" (ngModelChange)="includeDocumentPDFChanged()"
          *ngIf="showMainDoc">
          {{ "Include Document PDF" | locale }}
        </label>
        <label *ngFor="let layout of additionalLayouts" nz-checkbox [ngModel]="additionalLayoutsToAdd.has(layout.Id)"
          [nzChecked]="additionalLayoutsToAdd.has(layout.Id)" (ngModelChange)="
            multiDoc
              ? includeMutliAdditionalLayouts(layout, $event)
              : includeAdditionalLayout(layout, $event)
          ">{{ layout.Description | locale }}
        </label>

        <span style="text-align: left; padding-right: 50px; padding-left: 15px" *ngFor="let file of attachedDocs">
          <button nz-button style="border-radius: 10px" class="md-icon-button md-raised" (click)="displayDocumentPDF()">
            <!-- <i class="icon-file-pdf" style="font-size: 20px; color: red"></i> -->
            <i class="far fa-file-pdf" style="font-size: 15px; color: red"></i>
            &nbsp; {{ file.AttachName }}
          </button>
        </span>
        <span style="text-align: left; padding-right: 50px; padding-left: 15px"
          *ngFor="let file of additionalLayoutsToPreview">
          <button nz-button style="border-radius: 10px" class="md-icon-button md-raised" (click)="
              displayDocumentPDF(
                file.LayoutId == null ? file.Id : file.LayoutId,
                file.DocEntry
              )
            ">
            <!-- <i class="icon-file-pdf" style="font-size: 20px; color: red"></i> -->
            <i class="far fa-file-pdf" style="font-size: 15px; color: red"></i>
            &nbsp;

            {{
            file.Description == null || file.Description == ""
            ? file.Description + " " + this.recordModel.KeyValue
            : file.Description
            }}
          </button>
        </span>

        <nz-space-item class="tab-item">
          <input nz-input placeholder="{{ 'Subject' | locale }}" [(ngModel)]="emailSubject" />
        </nz-space-item>

        <nz-space-item class="tab-item">
          <!-- <textarea rows="4" nz-input [(ngModel)]="remark"></textarea> -->
          <div [ngxSummernote]="config" [(ngModel)]="remark"></div>
        </nz-space-item>

        <div style="text-align: right">
          <button nz-button nzType="primary" [nzLoading]="uploading" (click)="createCommunication(tab.name)">
            {{ uploading ? "Create" : ("Creating" | locale)
            }}<i nz-icon nzType="send" nzTheme="outline"></i>
          </button>
        </div>
      </div>
      <div *ngIf="tab.label === 'Phone'">
        <nz-form-item>
          <nz-form-label [nzSpan]="6">
            {{ "Assigned To" | locale }}
          </nz-form-label>
          <nz-form-control>
            <nz-select [(ngModel)]="listOfTagOptions" nzPlaceHolder="{{ 'Assign to Employees' | locale }}" nzShowSearch>
              <nz-option *ngFor="let option of listOfOption" [nzLabel]="option.label" [nzValue]="option.value">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="6">
            {{ "Subject" | locale }}
          </nz-form-label>
          <nz-form-control>
            <nz-select [(ngModel)]="communicatParam.Conversation_Subject" nzPlaceHolder="{{ 'Subject' | locale }}" nzShowSearch>
              <nz-option *ngFor="let option of listOfSubjectOptions" [nzLabel]="option.label" [nzValue]="option.value">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="6">
            {{ "Date" | locale }}
          </nz-form-label>
          <nz-form-control [nzSpan]="18">
            <nz-date-picker [(ngModel)]="communicatParam.Conversation_Recontact" (ngModelChange)="onChange($event)">
            </nz-date-picker>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="6">
            {{ "Start time" | locale }}
          </nz-form-label>
          <nz-form-control [nzSpan]="18">
            <nz-time-picker [(ngModel)]="communicatParam.Conversation_StartTime" nzFormat="HH:mm"></nz-time-picker>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="6">
            {{ "End time" | locale }}
          </nz-form-label>
          <nz-form-control [nzSpan]="18">
            <nz-time-picker [(ngModel)]="communicatParam.Conversation_EndTime" nzFormat="HH:mm"></nz-time-picker>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="6">
            {{ "Content" | locale }}
          </nz-form-label>
          <nz-form-control [nzSpan]="18">
            <textarea rows="4" nz-input [(ngModel)]="communicatParam.Conversation_Notes"
              [innerHTML]="communicatParam.Conversation_Notes"></textarea>
          </nz-form-control>
        </nz-form-item>
        <div style="text-align: right">
          <nz-space nzDirection="vertical">
            <nz-space-item *ngIf="ShowShareCheckBox">
              <label nz-checkbox [(ngModel)]="ITM_HELP_ISPUP">{{
                "Share with the customer"
                }}</label>
            </nz-space-item>
            <nz-space-item>
              <button nz-button nzType="primary" [disabled]="
                  communicatParam.Conversation_Recontact === undefined ||
                  communicatParam.Conversation_StartTime === undefined ||
                  communicatParam.Conversation_EndTime === undefined ||
                  ( ContentIsMandatory &&
                  (communicatParam.Conversation_Notes == null ||
                  communicatParam.Conversation_Notes == ''))
                " (click)="
                  communicatParam.CommunicationType = 0;
                  createCommunication(tab.name)
                ">
                {{ "Create" | locale
                }}<i nz-icon nzType="send" nzTheme="outline"></i>
              </button>
            </nz-space-item>
          </nz-space>
        </div>
      </div>
      <div *ngIf="tab.label === 'Meeting'">
        <nz-form-item>
          <nz-form-label [nzSpan]="6">
            {{ "Assigned To" | locale }}
          </nz-form-label>
          <nz-form-control>
            <nz-select [(ngModel)]="listOfTagOptions" nzPlaceHolder="{{ 'Assign to Employees' | locale }}" nzShowSearch>
              <nz-option *ngFor="let option of listOfOption" [nzLabel]="option.label" [nzValue]="option.value">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="6">
            {{ "Subject" | locale }}
          </nz-form-label>
          <nz-form-control>
            <nz-select [(ngModel)]="communicatParam.Meeting_Subject" nzPlaceHolder="{{ 'Subject' | locale }}" nzShowSearch>
              <nz-option *ngFor="let option of listOfSubjectOptions" [nzLabel]="option.label" [nzValue]="option.value">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="6">
            {{ "Date" | locale }}
          </nz-form-label>
          <nz-form-control [nzSpan]="18">
            <nz-date-picker [(ngModel)]="communicatParam.Meeting_Recontact" (ngModelChange)="onChange($event)">
            </nz-date-picker>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="6">
            {{ "Start time" | locale }}
          </nz-form-label>
          <nz-form-control [nzSpan]="18">
            <nz-time-picker [(ngModel)]="communicatParam.Meeting_StartTime" nzFormat="HH:mm"></nz-time-picker>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="6">
            {{ "End time" | locale }}
          </nz-form-label>
          <nz-form-control [nzSpan]="18">
            <nz-time-picker [(ngModel)]="communicatParam.Meeting_EndTime" nzFormat="HH:mm"></nz-time-picker>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="6">
            {{ "Content" | locale }}
          </nz-form-label>
          <nz-form-control [nzSpan]="18">
            <textarea rows="4" nz-input [(ngModel)]="communicatParam.Meeting_Notes"
              [innerHTML]="communicatParam.Meeting_Notes"></textarea>
          </nz-form-control>
        </nz-form-item>
        <div style="text-align: right">
          <nz-space nzDirection="vertical">
            <nz-space-item *ngIf="ShowShareCheckBox">
              <label nz-checkbox [(ngModel)]="ITM_HELP_ISPUP">{{
                "Share with the customer"
                }}</label>
            </nz-space-item>
            <nz-space-item>
              <button nz-button nzType="primary" [disabled]="
                  communicatParam.Meeting_Recontact === undefined ||
                  communicatParam.Meeting_StartTime === undefined ||
                  communicatParam.Meeting_EndTime === undefined ||
                  ( ContentIsMandatory && (
                  communicatParam.Meeting_Notes == null ||
                  communicatParam.Meeting_Notes == '' )) ||
                  communicatParam.Meeting_StartTime >
                    communicatParam.Meeting_EndTime
                " (click)="
                  communicatParam.CommunicationType = 1;
                  createCommunication(tab.name)
                ">
                {{ "Create" | locale
                }}<i nz-icon nzType="send" nzTheme="outline"></i>
              </button>
            </nz-space-item>
          </nz-space>
        </div>
      </div>
      <div *ngIf="tab.label === 'Task'">
        <nz-form-item>
          <nz-form-label [nzSpan]="6">
            {{ "Assigned To" | locale }}
          </nz-form-label>
          <nz-form-control>
            <nz-select [(ngModel)]="listOfTagOptions" nzPlaceHolder="{{ 'Assign to Employees' | locale }}" nzShowSearch>
              <nz-option *ngFor="let option of listOfOption" [nzLabel]="option.label" [nzValue]="option.value">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="6">
            {{ "Subject" | locale }}
          </nz-form-label>
          <nz-form-control>
            <nz-select [(ngModel)]="communicatParam.Task_Subject" nzPlaceHolder="{{ 'Subject' | locale }}" nzShowSearch>
              <nz-option *ngFor="let option of listOfSubjectOptions" [nzLabel]="option.label" [nzValue]="option.value">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="6">
            {{ "Start Date" | locale }}
          </nz-form-label>
          <nz-form-control [nzSpan]="18">
            <nz-date-picker [(ngModel)]="communicatParam.Task_Recontact" (ngModelChange)="onChange($event)">
            </nz-date-picker>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="6">
            {{ "Start time" | locale }}
          </nz-form-label>
          <nz-form-control [nzSpan]="18">
            <nz-time-picker [(ngModel)]="communicatParam.Task_StartTime" nzFormat="HH:mm"></nz-time-picker>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="6">
            {{ "End Date" | locale }}
          </nz-form-label>
          <nz-form-control [nzSpan]="18">
            <nz-date-picker [(ngModel)]="communicatParam.Task_EndDate" (ngModelChange)="onChange($event)">
            </nz-date-picker>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="6">
            {{ "End time" | locale }}
          </nz-form-label>
          <nz-form-control [nzSpan]="18">
            <nz-time-picker [(ngModel)]="communicatParam.Task_EndTime" nzFormat="HH:mm"></nz-time-picker>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="6">
            {{ "Content" | locale }}
          </nz-form-label>
          <nz-form-control [nzSpan]="18">
            <textarea rows="4" nz-input [(ngModel)]="communicatParam.Task_Notes"
              [innerHTML]="communicatParam.Task_Notes"></textarea>
          </nz-form-control>
        </nz-form-item>
        <div style="text-align: right">
          <nz-space nzDirection="vertical">
            <nz-space-item *ngIf="ShowShareCheckBox">
              <label nz-checkbox [(ngModel)]="ITM_HELP_ISPUP">{{
                "Share with the customer"
                }}</label>
            </nz-space-item>
            <nz-space-item>
              <button nz-button nzType="primary" [disabled]="
                  communicatParam.Task_Recontact === undefined ||
                  communicatParam.Task_StartTime === undefined ||
                  communicatParam.Task_EndDate === undefined ||
                  communicatParam.Task_EndTime === undefined ||
                  ( ContentIsMandatory && (
                  communicatParam.Task_Notes == null ||
                  communicatParam.Task_Notes == ''))
                " (click)="
                  communicatParam.CommunicationType = 2;
                  createCommunication(tab.name)
                ">
                {{ "Create" | locale
                }}<i nz-icon nzType="send" nzTheme="outline"></i>
              </button>
            </nz-space-item>
          </nz-space>
        </div>
      </div>
      <div *ngIf="tab.label === 'Note'">
        <!--
          To DO:: Create configuration to hide assigned to by default.
        -->
        <!-- <nz-form-item>
          <nz-form-label [nzSpan]="6">
            {{ "Assigned To" | locale }}
          </nz-form-label>
          <nz-form-control>
            <nz-select
              [(ngModel)]="listOfTagOptions"
              nzPlaceHolder="{{ 'Assign to Employees' | locale }}"
            >
              <nz-option
                *ngFor="let option of listOfOption"
                [nzLabel]="option.label"
                [nzValue]="option.value"
              >
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item> -->
        <nz-form-item>
          <nz-form-label [nzSpan]="6">
            {{ "Subject" | locale }}
          </nz-form-label>
          <nz-form-control>
            <nz-select [(ngModel)]="communicatParam.Note_Subject" nzPlaceHolder="{{ 'Subject' | locale }}" nzShowSearch>
              <nz-option *ngFor="let option of listOfSubjectOptions" [nzLabel]="option.label" [nzValue]="option.value">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="6">
            {{ "Content" | locale }}
          </nz-form-label>
          <nz-form-control [nzSpan]="18">
            <textarea rows="4" nz-input [(ngModel)]="communicatParam.Note_Notes"
              [innerHTML]="communicatParam.Note_Notes"></textarea>
          </nz-form-control>
        </nz-form-item>
        <div style="text-align: right">
          <nz-space nzDirection="vertical">
            <nz-space-item *ngIf="ShowShareCheckBox">
              <label nz-checkbox [(ngModel)]="ITM_HELP_ISPUP">{{
                "Share with the customer"
                }}</label>
            </nz-space-item>
            <nz-space-item>
              <button nz-button nzType="primary" [disabled]="
                   ContentIsMandatory && (communicatParam.Note_Notes == null ||
                  communicatParam.Note_Notes == '')
                " (click)="
                  communicatParam.CommunicationType = 4;
                  createCommunication(tab.name)
                ">
                {{ "Create" | locale
                }}<i nz-icon nzType="send" nzTheme="outline"></i>
              </button>
            </nz-space-item>
          </nz-space>
        </div>
      </div>
      <div *ngIf="tab.label === 'Activities'" style="min-height: 260px; height: 600px !important">
        <nz-space-item style="min-height: 260px; width: 100% !important">
          <nz-space style="
              width: 100% !important;
              padding: 0px;
              margin-left: 0px;
              margin-left: auto;
              font-size: large;
            ">
            <nz-space-item style="width: 100% !important; padding: 0px; margin-left: 0px">
              <div style="min-height: 260px">
                <nz-list style="
                    min-height: 260px;
                    width: 100% !important;
                    max-height: 600px;
                    height: 100%;
                  " [nzDataSource]="activitiesData" [nzRenderItem]="item" [nzItemLayout]="'horizontal'"
                  class="records-list-comm">
                  <nz-list-item>
                    <nz-skeleton *ngIf="!activitiesData.entries" [nzAvatar]="true" [nzParagraph]="{ rows: 1 }">
                    </nz-skeleton>
                    <ng-template #item let-item>
                      <nz-comment [nzAuthor]="item.AttendUser" [nzDatetime]="item.Recontact">
                        <nz-avatar nz-comment-avatar *ngIf="item.Action == 'C'" nzIcon="phone" style="margin: auto">
                        </nz-avatar>
                        <nz-avatar nz-comment-avatar *ngIf="item.Action == 'M'" nzIcon="deployment-unit"
                          style="margin: auto"></nz-avatar>
                        <nz-avatar nz-comment-avatar *ngIf="item.Action == 'T'" nzIcon="unordered-list"
                          style="margin: auto"></nz-avatar>
                        <nz-avatar nz-comment-avatar *ngIf="item.Action == 'N'" nzIcon="mail" style="margin: auto">
                        </nz-avatar>
                        <nz-avatar nz-comment-avatar *ngIf="item.Action == 'E'" nzIcon="book" style="margin: auto">
                        </nz-avatar>
                        <div nzIcon="fund-view" style="margin-left: -15px" *ngIf="
                            item.Action == 'N' && item.U_ITM_BWEB_READ === 'Y'
                          ">
                          <nz-badge style="margin-right: auto" [nzCount]="item.U_ITM_BWEB_CREAD">
                            <button nz-button nz-dropdown [nzDropdownMenu]="menu" class="email-not-badge"
                              nzClickHide="false" nzTrigger="hover" nzPlacement="bottomRight">
                              <i nz-icon nzType="eye" nzTheme="outline"></i>
                            </button>
                          </nz-badge>
                          <nz-dropdown-menu #menu="nzDropdownMenu">
                            <ul nz-menu>
                              <li nz-menu-item>
                                <h2>{{ "Viewed At" | locale }}</h2>
                              </li>
                              <li nz-menu-item *ngFor="
                                  let item of item.U_ITM_BWEB_DREAD.split(';')
                                ">
                                <nz-tag [nzColor]="'green'" *ngIf="item !== ''">{{ item }}</nz-tag>
                              </li>
                            </ul>
                          </nz-dropdown-menu>
                        </div>

                        <nz-comment-content style="cursor: pointer" (click)="navigateTo(25, item.ClgCode)">
                          <ng-container>
                            <div style="margin: 2px">
                              <div style="float: left; margin: 2px">
                                <p style="margin: 2px">
                                  {{ item.BeginTime | minuteSeconds }}
                                  {{
                                  item.BeginTime === item.ENDTime ||
                                  item.ENDTime == null
                                  ? ""
                                  : " - " + (item.ENDTime | minuteSeconds)
                                  }}
                                </p>
                                <p style="margin: 2px" [innerHTML]="item.Notes"></p>
                              </div>
                              <div style="display: inline-block">
                                <nz-tag style="margin: 5px" *ngIf="item.AttendEmpl !== ' '">{{ item.AttendEmpl }}
                                </nz-tag>
                              </div>
                            </div>
                          </ng-container>
                          <nz-button-group class="activity-list-edit-btn">
                            <a nz-button nzType="link" (click)="navigateTo(25, item.ClgCode)"><i nz-icon nzType="edit"
                                nzTheme="outline"></i></a>
                          </nz-button-group>
                        </nz-comment-content>
                      </nz-comment>
                      <nz-divider></nz-divider>
                    </ng-template>
                  </nz-list-item>
                </nz-list>
              </div>
            </nz-space-item>
          </nz-space>
        </nz-space-item>
      </div>
    </nz-tab>
  </nz-tabset>
</ng-container>
